import React, { useState } from 'react'
import { AgGridReact } from "ag-grid-react";
import ModalBasic from '../../component/ModalBasic';
import TextInput from '../../../components/UIComponent/TextInput';
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown';
import ButtonLoader from '../../../components/common/buttonLoader/ButtonLoader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';


export const ReworkProductTable = (props) => {

    const itemColdefs = [
        {
            field: "drawingNo",
            headerName: "Drawing No",
            minWidth: window.innerWidth * 0.09,
            flex: 1.6,
            filter: true,
            floatingFilter: true,
        },
        {
            field: "itemDetails",
            headerName: "Item details",
            minWidth: window.innerWidth * 0.2,
            flex: 2,
            filter: true,
            floatingFilter: true,
        },
        {
            field: "itemType",
            headerName: "Item Type",
            minWidth: window.innerWidth * 0.09,
            flex: 0.8,
            filter: true,
            floatingFilter: true,
        },
        {
            field: "itemRate",
            headerName: "Item Rate",
            minWidth: window.innerWidth * 0.06,
            flex: 0.6,
            filter: true,
            floatingFilter: true,
        },
        {
            field: "currentStock",
            headerName: "Current stock",
            minWidth: window.innerWidth * 0.06,
            flex: 0.8,
            filter: true,
            floatingFilter: true,
        },
        {
            field: "requiredQuantity",
            headerName: "Required quantity",
            minWidth: window.innerWidth * 0.09,
            flex: 0.8,
            filter: true,
            floatingFilter: true,
        },
        {
            field: "totalRequireQty",
            headerName: "Total required qty",
            minWidth: window.innerWidth * 0.09,
            flex: 0.8,
            filter: true,
            floatingFilter: true,
        },
        {
            field: "Action",
            headerName: "Action",
            minWidth: window.innerWidth * 0.07,
            flex: 0.1,
            filter: false,
            floatingFilter: false,
            cellClass: "action-col !p-0 flex items-center justify-center",
            cellRenderer: (params) => (
                <div className="flex items-center justify-center gap-2">
                    <button
                        onClick={() => props.removeItemFromTables(params.data, 'bomItems')}
                        className='delete-btn w-fit p-2.5 h-[30px] flex items-center justify-center rounded-[5px]'
                        title="Delete"
                    >
                        <FontAwesomeIcon icon={faTrash} />
                    </button>

                </div>
            ),
        }
    ];
    const bomColdefs = [
        {
            field: "drawingNo",
            headerName: "Drawing No",
            minWidth: window.innerWidth * 0.09,
            flex: 0.6,
            filter: true,
            floatingFilter: true,
        },
        {
            field: "itemDetails",
            headerName: "Item details",
            minWidth: window.innerWidth * 0.16,
            flex: 1.6,
            filter: true,
            floatingFilter: true,
        },
        {
            field: "itemRate",
            headerName: "Item Rate",
            minWidth: window.innerWidth * 0.06,
            flex: 0.6,
            filter: true,
            floatingFilter: true,
        },
        {
            field: "currentStock",
            headerName: "Current stock",
            minWidth: window.innerWidth * 0.06,
            flex: 0.8,
            filter: true,
            floatingFilter: true,
        },
        {
            field: "quantity",
            headerName: "Qty",
            minWidth: window.innerWidth * 0.06,
            flex: 0.6,
            filter: true,
            floatingFilter: true,
        },
        {
            field: "Action",
            headerName: "Action",
            minWidth: window.innerWidth * 0.07,
            flex: 0.1,
            filter: false,
            floatingFilter: false,
            cellClass: "action-col !p-0 flex items-center justify-center",
            cellRenderer: (params) => (
                <div className="flex items-center justify-center gap-2">
                    <button
                        onClick={() => props.removeItemFromTables(params.data, 'bomRemove')}
                        className='delete-btn w-fit p-2.5 h-[30px] flex items-center justify-center rounded-[5px]'
                        title="Delete"
                    >
                        <FontAwesomeIcon icon={faTrash} />
                    </button>

                </div>
            ),
        }
    ];

    const reworkColdefs = [
        {
            field: "drawingNo",
            headerName: "Drawing No",
            minWidth: window.innerWidth * 0.09,
            flex: 1.6,
            filter: true,
            floatingFilter: true,
        },
        {
            field: "itemDetails",
            headerName: "Item details",
            minWidth: window.innerWidth * 0.16,
            flex: 1.6,
            filter: true,
            floatingFilter: true,
        },
        {
            field: "itemType",
            headerName: "Item Type",
            minWidth: window.innerWidth * 0.08,
            flex: 0.8,
            filter: true,
            floatingFilter: true,
        },
        {
            field: "process",
            headerName: "Process",
            minWidth: window.innerWidth * 0.08,
            flex: 0.8,
            filter: true,
            floatingFilter: true,
        },
        {
            field: "employeeName",
            headerName: "Employee Name",
            minWidth: window.innerWidth * 0.16,
            flex: 1.6,
            filter: true,
            floatingFilter: true,
        },
        {
            field: "processRates",
            headerName: "Process Rates",
            minWidth: window.innerWidth * 0.06,
            flex: 0.6,
            filter: true,
            floatingFilter: true,
        },
        {
            field: "quantity",
            headerName: "Qty",
            minWidth: window.innerWidth * 0.06,
            flex: 0.6,
            filter: true,
            floatingFilter: true,
        },
        {
            field: "isCompleteProcess",
            headerName: "Is Complete",
            minWidth: window.innerWidth * 0.07,
            flex: 0.6,
            filter: true,
            floatingFilter: true,
        },
        {
            field: "completeDate",
            headerName: "Complete Date",
            minWidth: window.innerWidth * 0.09,
            flex: 0.6,
            filter: true,
            floatingFilter: true,
            valueFormatter: (params) => {
                if (!params.value) return "";
                return moment(params.value).format("DD-MM-YYYY");
            }
        },
        {
            field: "Action",
            headerName: "Action",
            minWidth: window.innerWidth * 0.07,
            flex: 0.1,
            filter: false,
            floatingFilter: false,
            cellClass: "action-col !p-0 flex items-center justify-center",
            cellRenderer: (params) => (
                <div className="flex items-center justify-center gap-2">
                    <button
                        onClick={() => props.removeItemFromTables(params.data, 'bomRework')}
                        className='delete-btn w-fit p-2.5 h-[30px] flex items-center justify-center rounded-[5px]'
                        title="Delete"
                    >
                        <FontAwesomeIcon icon={faTrash} />
                    </button>

                </div>
            ),
        }
    ];
    return (
        <ModalBasic
            id="rework-product"
            classParams="!w-[80%] overflow-y-auto"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            <div className='input-fields p-[30px]'>
                <span className="text-blue text-[16px] font-semibold">Rework Product</span>
                <div className='item-grp grid grid-cols-5 gap-2.5 mt-3 mb-2 pb-[8px] border-b border-slate-200 items-start'>
                    <div className='input-grp'>
                        <label>Rework no</label>
                        <TextInput type='text'
                            id='reworkNo' name='reworkNo'
                            value={props.reworkObject.reworkNo}
                            handleChange={(event) => props.handleChangeForRework(event, 'reworkNo')}
                            className={props.validState?.error?.reworkNo !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Rework date</label>
                        <TextInput type='date'
                            id='reworkDate' name='reworkDate'
                            value={props.reworkObject.reworkDate}
                            handleChange={(event) => props.handleChangeForRework(event, 'reworkDate')}
                            className={props.validState?.error?.reworkDate !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Rework type</label>
                        <MultiSelectDropdown
                            drpIdentity="Select type"
                            options={props.reworkObject.reworkTypeList}
                            value={props.reworkObject.idReworkType ? props.reworkObject.reworkTypeList.find(x => x.value === props.reworkObject.idReworkType) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idReworkType", 'reworkObject')
                            }
                            className={props.validState?.error?.idReworkType !== undefined ? "error" : ""}
                        />
                    </div>
                    {/* <div className='input-grp'>
                        <label>JW out</label>
                        <MultiSelectDropdown
                            drpIdentity="Select jw out"
                            options={props.reworkObject.jwOutList}
                            value={props.reworkObject.idJwOut ? props.reworkObject.jwOutList.find(x => x.value === props.reworkObject.idJwOut) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idJwOut", 'reworkObject')
                            }
                            className={props.validState?.error?.idJwOut !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>JW out date</label>
                        <TextInput type='date'
                            id='jwOutDate' name='jwOutDate'
                            value={props.reworkObject.jwOutDate}
                            handleChange={(event) => props.handleChangeForRework(event, 'jwOutDate')}
                            className={props.validState?.error?.jwOutDate !== undefined ? "error" : ""}
                        />
                    </div> */}
                    <div className='input-grp col-span-2'>
                        <label>Select product</label>
                        {/* <MultiSelectDropdown
                            drpIdentity="Select product"
                            options={props.reworkObject.productList}
                            value={props.reworkObject.idProduct ? props.reworkObject.productList.find(x => x.value === props.reworkObject.idProduct) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idProduct", 'reworkObject')
                            }
                            className={props.validState?.error?.idProduct !== undefined ? "error" : ""}
                        /> */}
                        <TextInput
                            id="idProduct"
                            name="idProduct"
                            value={props.reworkObject.productName}
                            handleOnClick={(event) => props.handleOnClick(event, "idProduct")}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Avl stock</label>
                        <TextInput type='number'
                            id='avlStock' name='avlStock'
                            value={props.reworkObject.avlStock}
                            handleChange={(event) => props.handleChangeForRework(event, 'avlStock')}
                            className={props.validState?.error?.avlStock !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Rework Qty</label>
                        <TextInput type='number'
                            id='reworkQty' name='reworkQty'
                            value={props.reworkObject.reworkQty}
                            handleChange={(event) => props.handleChangeForRework(event, 'reworkQty')}
                            className={props.validState?.error?.reworkQty !== undefined ? "error" : ""}
                        />
                    </div>
                    {/* <div className='input-grp'>
                        <label>Serial no</label>
                        <TextInput type='number'
                            id='srNo' name='srNo'
                            value={props.reworkObject.srNo}
                            handleChange={(event) => props.handleChangeForRework(event, 'srNo')}
                            className={props.validState?.error?.srNo !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>JW in</label>
                        <TextInput type='text'
                            id='jwIn' name='jwIn'
                            value={props.reworkObject.jwIn}
                            handleChange={(event) => props.handleChangeForRework(event, 'jwIn')}
                            className={props.validState?.error?.jwIn !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>JW in date</label>
                        <TextInput type='date'
                            id='jwInDate' name='jwInDate'
                            value={props.reworkObject.jwInDate}
                            handleChange={(event) => props.handleChangeForRework(event, 'jwInDate')}
                            className={props.validState?.error?.jwInDate !== undefined ? "error" : ""}
                        />
                    </div> */}
                    <div className='input-grp'>
                        <label>Select plant</label>
                        <MultiSelectDropdown
                            drpIdentity="Select plant"
                            options={props.reworkObject.plantList}
                            value={props.reworkObject.idPlant ? props.reworkObject.plantList.find(x => x.value === props.reworkObject.idPlant) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idPlant", 'reworkObject')
                            }
                            className={props.validState?.error?.idPlant !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp !inline-flex flex-row-reverse items-center justify-end !gap-[8px] mt-8'>
                        <label>Rework is complete?</label>
                        <input type='CheckBox'
                            className='shadow-none w-[16px] h-[16px]'
                            id='isCompleteRework' name='isCompleteRework'
                            checked={props.reworkObject.isCompleteRework === true ? true : false}
                            onClick={(event) => props.handleChangeForRework(event, 'isCompleteRework')}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Date</label>
                        <TextInput type='date'
                            id='completeDate' name='completeDate'
                            value={props.reworkObject.completeDate}
                            handleChange={(event) => props.handleChangeForRework(event, 'completeDate')}
                            className={props.validState?.error?.completeDate !== undefined ? "error" : ""}
                        />
                    </div>
                    {/* <div className='input-grp'>
                        <label>Process</label>
                        <MultiSelectDropdown
                            drpIdentity="Select inv"
                            options={props.reworkObject.processList}
                            value={props.reworkObject.idProcess ? props.reworkObject.processList.find(x => x.value === props.reworkObject.idProcess) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idProcess", 'reworkObject')
                            }
                            className={props.validState?.error?.idProcess !== undefined ? "error" : ""}
                        />
                    </div> */}
                    <div className='btn-grp flex gap-2.5 col-span-2'>
                        {props.isLoading ?
                            <ButtonLoader />
                            :
                            <button
                                className="save-btn btns py-[10px] px-[20px] h-[40px]"
                                onClick={() => props.addWoBomData()}
                            >
                                Add bom data
                            </button>
                        }
                        <button
                            className="save-btn btns py-[10px] px-[20px] h-[40px]"
                            onClick={() => props.generateReportForReworkProduct()}
                        >
                            Print Rework
                        </button>
                    </div>
                </div>

                <span className="text-blue text-[16px] font-semibold">Item details</span>
                <div className='item-grp grid grid-cols-5 gap-2.5 mt-3 mb-2 pb-[8px] border-b border-slate-200 items-start'>
                    {props.activeTab === 'items' || props.activeTab === 'removed' ?
                        <>
                            <div className='input-grp col-span-3'>
                                <label>Item name</label>
                                <MultiSelectDropdown
                                    drpIdentity="Select item"
                                    options={props.itemObject.itemList}
                                    value={props.itemObject.idItem ? props.itemObject.itemList.find(x => x.value === props.itemObject.idItem) : 0}
                                    onChange={(event) =>
                                        props.handleChangeForDropdown(event, "idItem", 'itemObject')
                                    }
                                    className={props.validState?.error?.idItem !== undefined ? "error" : ""}
                                />
                            </div>
                            <div className='input-grp'>
                                <label>Stock</label>
                                <TextInput type='number'
                                    id='stock' name='stock'
                                    value={props.itemObject.stock}
                                    handleChange={(event) => props.handleChangeForItem(event, 'stock')}
                                    className={props.validState?.error?.stock !== undefined ? "error" : ""}
                                    disabled
                                />
                            </div>
                            <div className='input-grp'>
                                <label>Quantity</label>
                                <TextInput type='number'
                                    id='quantity' name='quantity'
                                    value={props.itemObject.quantity}
                                    handleChange={(event) => props.handleChangeForItem(event, 'quantity')}
                                    className={props.validState?.error?.quantity !== undefined ? "error" : ""}
                                />
                            </div>
                        </>
                        : null}

                    {props.activeTab === 'rework' ?
                        <>
                            <div className='input-grp col-span-3'>
                                <label>Item name</label>
                                <TextInput type='text'
                                    id='itemName' name='itemName'
                                    value={props.reworkItemObject.itemName}
                                    handleChange={(event) => props.handleChangeForReworkItem(event, 'itemName')}
                                    className={props.validState?.error?.itemName !== undefined ? "error" : ""}
                                    disabled
                                />
                            </div>
                            <div className='input-grp'>
                                <label>Quantity</label>
                                <TextInput type='number'
                                    id='quantity' name='quantity'
                                    value={props.reworkItemObject.quantity}
                                    handleChange={(event) => props.handleChangeForReworkItem(event, 'quantity')}
                                    className={props.validState?.error?.quantity !== undefined ? "error" : ""}
                                />
                            </div>
                            <div className='input-grp col-span'>
                                <label>Process</label>
                                <MultiSelectDropdown
                                    drpIdentity="Select process"
                                    options={props.reworkItemObject.processList}
                                    value={props.reworkItemObject.idProcess ? props.reworkItemObject.processList.find(x => x.value === props.reworkItemObject.idProcess) : 0}
                                    onChange={(event) =>
                                        props.handleChangeForDropdown(event, "idProcess", 'reworkItemObject')
                                    }
                                    className={props.validState?.error?.idProcess !== undefined ? "error" : ""}
                                />
                            </div>
                            <div className='input-grp col-span-2'>
                                <label>Employee</label>
                                <MultiSelectDropdown
                                    drpIdentity="Select item"
                                    options={props.reworkItemObject.employeeList}
                                    value={props.reworkItemObject.idEmployee ? props.reworkItemObject.employeeList.find(x => x.value === props.reworkItemObject.idEmployee) : 0}
                                    onChange={(event) =>
                                        props.handleChangeForDropdown(event, "idEmployee", 'reworkItemObject')
                                    }
                                    className={props.validState?.error?.idEmployee !== undefined ? "error" : ""}
                                />
                            </div>
                            <div className='input-grp col-span'>
                                <label>Process Rates</label>
                                <TextInput type='number'
                                    id='processRates' name='processRates'
                                    value={props.reworkItemObject.processRates}
                                    handleChange={(event) => props.handleChangeForReworkItem(event, 'processRates')}
                                    className={props.validState?.error?.processRates !== undefined ? "error" : ""}
                                />
                            </div>
                            <div className='input-outer !h-full grid grid-cols-2 gap-[10px] col-span-2'>
                                <div className='input-grp !inline-flex flex-row-reverse justify-end !gap-[10px] mt-8'>
                                    <label>Process is complete?</label>
                                    <input type='CheckBox'
                                        className='shadow-none w-[15px] h-[15px]'
                                        id='isCompleteProcess' name='isCompleteProcess'
                                        checked={props.reworkItemObject.isCompleteProcess === true ? true : false}
                                        onClick={(event) => props.handleChangeForReworkItem(event, 'isCompleteProcess')}
                                    />
                                </div>
                                <div className='input-grp'>
                                    <label>Date</label>
                                    <TextInput type='date'
                                        id='completeDate' name='completeDate'
                                        value={props.reworkItemObject.completeDate}
                                        handleChange={(event) => props.handleChangeForReworkItem(event, 'completeDate')}
                                        className={props.validState?.error?.completeDate !== undefined ? "error" : ""}
                                    />
                                </div>
                            </div>
                        </>
                        : null}

                    <div className='btn-grp flex gap-2.5 col-span-1 col-start-5'>
                        {props.activeTab === 'items' ?
                            <button
                                className="save-btn btns py-[10px] px-[20px] h-[40px] ml-auto"
                                onClick={() => props.insert("Insert")}
                            >
                                {props.formStatus === 1 ? 'Update' : 'Insert'}
                            </button>
                            : null}
                        {props.activeTab === 'removed' ?
                            <button
                                className="save-btn btns py-[10px] px-[20px] h-[40px] ml-auto"
                                onClick={() => props.updateBOMRemovedObject()}
                            >
                                Update
                            </button>
                            : null}
                        {props.activeTab === 'rework' ?
                            <button
                                className="save-btn btns py-[10px] px-[20px] h-[40px] ml-auto"
                                onClick={() => props.updateReworkObject()}
                            >
                                Update
                            </button>
                            : null}
                        {/* <button className="edit-btn btns py-[10px] px-[20px] h-[40px]"
                            onClick={() => props.clearItem()}
                            disabled={activeTab !== 'items'}
                        >
                            Clear
                        </button>
                        <button className="delete-btn btns py-[10px] px-[20px] h-[40px]"
                            onClick={() => props.deleteItem()}
                            disabled={activeTab !== 'items'}
                        >
                            Delete
                        </button> */}
                        {/* <button className="remove-btn btns py-[10px] px-[20px] h-[40px] text-red-500 bg-red-50 hover:bg-red-100 hover:text-red-600"
                            onClick={() => props.removeBomItem()}>
                            Remove
                        </button> */}
                    </div>
                </div>
                <div className="register-table mt-2.5">
                    <div className='tabbing-grp flex items-center gap-2.5'>
                        <button
                            onClick={() => props.setActiveTab('items')}
                            className={`px-4 py-2 text-[16px] font-semibold transition-all relative rounded-[10px] ${props.activeTab === 'items'
                                ? 'text-white bg-blue'
                                : 'text-blue bg-blue/10 hover:bg-blue/20'
                                }`}
                        >
                            Item Details
                        </button>
                        <button
                            onClick={() => props.setActiveTab('removed')}
                            className={`px-4 py-2 text-[16px] font-semibold transition-all relative rounded-[10px] ${props.activeTab === 'removed'
                                ? 'text-white bg-blue'
                                : 'text-blue bg-blue/10 hover:bg-blue/20'
                                }`}
                        >
                            BOM Removed Items
                        </button>
                        <button
                            onClick={() => props.setActiveTab('rework')}
                            className={`px-4 py-2 text-[16px] font-semibold transition-all relative rounded-[10px] ${props.activeTab === 'rework'
                                ? 'text-white bg-blue'
                                : 'text-blue bg-blue/10 hover:bg-blue/20'
                                }`}
                        >
                            Rework Items
                        </button>
                    </div>
                    <div className="h-[40vh] mt-[10px]">
                        {props.activeTab === 'items' && (
                            <div className="h-full border border-gray-200 rounded-lg overflow-hidden shadow-sm animate-fadeIn">
                                <AgGridReact
                                    rowData={props.itemRowData}
                                    columnDefs={itemColdefs}
                                    onCellClicked={props.handleCellClickItemList}
                                    overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                    overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                    onRowDoubleClicked={props.onItemRowDoubleClicked}
                                />
                            </div>
                        )}
                        {props.activeTab === 'removed' && (
                            <div className="h-full border border-gray-200 rounded-lg overflow-hidden shadow-sm animate-fadeIn">
                                <AgGridReact
                                    rowData={props.bomRemovedRowData}
                                    columnDefs={bomColdefs}
                                    overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                    overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                    onRowDoubleClicked={props.onBomRowDoubleClicked}
                                />
                            </div>
                        )}
                        {props.activeTab === 'rework' && (
                            <div className="h-full border border-gray-200 rounded-lg overflow-hidden shadow-sm animate-fadeIn">
                                <AgGridReact
                                    rowData={props.reworkRowData}
                                    columnDefs={reworkColdefs}
                                    overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                    overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                    onRowDoubleClicked={props.onReworkDoubleClicked}
                                />
                            </div>
                        )}
                    </div>
                </div>
                <div className='btn-grp flex gap-2.5 mt-5'>
                    <button className="update-btn btns" onClick={() => props.submit()} disabled={props.isSaving}>
                        {props.reworkObject.idRework > 0 ? 'Update' : 'Save'}
                    </button>
                    {/* <button className="print-btn btns">Print</button>
                    <button className="edit-btn btns">Preview</button> */}
                    <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                </div>
            </div>

        </ModalBasic>
    )
}